
































import 'reflect-metadata'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { Chart } from 'chart.js'

@Component({
    components: {},
})
export default class Price extends Vue {
    // series = [1, 1, 1, 1, 1, 1, 1]
    lineColor = ''
    zeroLineColor = ''
    valueColor = ''
    get theme() {
        const data = (this as any).$root.theme
        this.lineColor = data === 'day' ? '#9d43f7' : '#BBF45C'
        this.zeroLineColor = data === 'day' ? '#00000033' : '#FFFFFF33'
        this.valueColor = data === 'night' ? '#fff' : '#9D43F7'
        return data
    }
    mounted() {
        Chart.platform.disableCSSInjection = true
        this.drawGraph()
    }
    @Watch('lineColor')
    @Watch('weeklyPrice')
    drawGraph() {
        const data = this.weeklyPrice
        const dataArr = [
            data[1],
            data[2],
            data[3],
            data[4],
            data[5],
            data[6],
            data[0],
        ]
        const highestPrice = Math.max(...dataArr)
        const intervals = highestPrice / 4
        const rootCanvasRef: any = this.$refs['validators_graph']
        const context = rootCanvasRef.getContext('2d')
        const _chart = new Chart(context, {
            type: 'line',
            data: {
                labels: ['Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'],
                datasets: [
                    {
                        label: 'Price',
                        data: dataArr,
                        fill: false,
                        borderColor: this.lineColor,
                    },
                ],
            },

            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    gridLines: {
                        display: false,
                    },
                    xAxes: [
                        {
                            gridLines: {
                                zeroLineColor: this.zeroLineColor,
                                color: 'transparent',
                            },
                            ticks: {
                                fontColor: this.valueColor,
                                fontSize: 12.5,
                                fontStyle: '600',
                            },
                            stacked: true,
                        },
                    ],

                    yAxes: [
                        {
                            gridLines: {
                                zeroLineColor: this.zeroLineColor,
                                color: 'transparent',
                            },
                            stacked: true,
                            ticks: {
                                fontColor: this.valueColor,
                                fontSize: 13,
                                padding: 10,
                                fontStyle: '600',
                                beginAtZero: true,
                                stepSize: intervals, // Intervals for graph
                                max: highestPrice + intervals, // Max value on graph
                            },
                        },
                    ],
                },
                tooltips: {
                    backgroundColor: 'transparent',
                    mode: 'x-axis',
                    bodyFontColor: '#9D43F7',
                    titleFontSize: 0,
                    bodyFontSize: 14,
                    bodyFontStyle: '600',
                },
                legend: {
                    display: false,
                },
                plugins: {
                    datalabels: {
                        display: false,
                    },
                },
            },
        })
    }
    get weeklyPrice(): any {
        console.log(this.$store.state.weeklyPrice)
        return this.$store.state.weeklyPrice
    }
    get price(): any {
        return this.$store.state.prices
    }
}
